import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Signin from './views/Signin.vue'
import Signout from './views/Signout.vue'
import Profile from './views/Profile.vue'
import Register from './views/Register.vue'
import Posts from './views/Posts.vue'
import Connect from './views/Connect.vue'
import Conversations from './views/Conversations.vue'
import Verification from './views/Verification.vue'
import Fundraisers from './views/Fundraisers.vue'
import Checkin from './views/Checkin.vue'
import Wall from './views/Wall.vue'
import Gallery from './views/Gallery.vue'
import FundraisersSubscription from './views/FundraisersSubscription.vue'
import Commerce from './views/Commerce.vue'
import SharedProduct from './views/SharedProduct.vue'
import RouteForwarder from './views/RouteForwarder.vue'


import AuthGuard from './auth-guard'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/',
      name: 'sharedproduct',
      component: SharedProduct
    },    
    {
      path: '/home',
      name: 'home',
      component: Home
    },    
    {
      path: '/store',
      name: 'store',
      component: Commerce,
      beforeEnter: AuthGuard
    },   
    {
      path: '/signout',
      name: 'signout',
      component: Signout
    },      
    {
      path: '/signin',
      name: 'signin',
      component: Signin
    },    
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      beforeEnter: AuthGuard
    },  
    {
      path: '/gallery',
      name: 'Gallery',
      component: Gallery,
      beforeEnter: AuthGuard
    },        
    {
      path: '/verify',
      name: 'Verify People',
      component: Verification,
      beforeEnter: AuthGuard
    },
    {
      path: '/timeline',
      name: 'Timeline',
      component: Wall,
      beforeEnter: AuthGuard
    },    
    {
      path: '/checkin',
      name: 'Checkin',
      component: Checkin,
      beforeEnter: AuthGuard
    },
    {
      path: '/endowment',
      name: 'Endowment',
      component: Fundraisers,
      beforeEnter: AuthGuard
    },
    {
      path: '/homecoming',
      name: 'Homecoming',
      component: Fundraisers,
      beforeEnter: AuthGuard
    },                    
    {
      path: '/conversations',
      name: 'Conversations',
      component: Conversations,
      beforeEnter: AuthGuard
    },       
    {
      path: '/business',
      name: 'Business',
      component: Posts,
      beforeEnter: AuthGuard
    },    
    {
      path: '/info',
      name: 'Info',
      component: Posts,
      beforeEnter: AuthGuard
    },     
    {
      path: '/event',
      name: 'Event',
      component: Posts,
      beforeEnter: AuthGuard
    },         
    {
      path: '/career',
      name: 'Career',
      component: Posts,
      beforeEnter: AuthGuard
    },     
    {
      path: '/register',
      name: 'Register',
      component: Register,
      beforeEnter: AuthGuard
    },     
    {
      path: '/connect',
      name: 'Connect',
      component: Connect,
      beforeEnter: AuthGuard
    },    
    {
      path: '/techassessment',
      name: 'Techassessment',
      component: FundraisersSubscription,
      beforeEnter: AuthGuard
    },     
    {
      path: '/forwarder',
      name: 'Forwarder',
      component: RouteForwarder,
      beforeEnter: AuthGuard
    },             
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
})
